import React from "react";
import ShoppingListItem from "../ShoppingListItem/shoppingListItem";

import "./shoppingList.css";

const ShoppingList = (props) => {
  return (
    <div className="shoppingList-Container">
      {
        !props.cartItems.length ? (
          <div className="empty-Cart">
            <h2>
              Cart is empty please add items!
            </h2>
          </div>
        ) :
          props.cartItems.map((item) => {
            return (
              <ShoppingListItem
                title={item.title}
                description={item.description}
                picture={
                  "https://res.cloudinary.com/dream-flowers-llc/image/upload/v1578958572/20180823_141941.jpg"
                }
                quantity={item.quantity}
                cost={item.cost}
                addToCart={props.addToCart}
                removeFromCart={props.removeFromCart}
                id={item.id}
              />
            );
          })

      }
    </div>
  );
};

export default ShoppingList;
